import { Center, Icon } from '@chakra-ui/react';
import { FiMessageCircle } from '@react-icons/all-files/fi/FiMessageCircle';

import UnreadCountBubble from '../../../../notifications/UnreadCountBubble';

type ConversationIconProps = {
  unreadCount?: number;
  boxSize?: string;
  iconBoxSize?: string;
};

const ConversationIcon = ({
  unreadCount = 0,
  boxSize = '36px',
  iconBoxSize = '17px',
}: ConversationIconProps) => (
  <Center
    position="relative"
    w={boxSize}
    h={boxSize}
    borderRadius="full"
    borderWidth="1px"
    borderColor="oceanBoatBlue"
    bg="iceBlue"
    color="oceanBoatBlue"
    flexShrink={0}
    _groupHover={{ bg: 'oceanBoatBlue', color: 'white' }}
  >
    <Icon as={FiMessageCircle} boxSize={iconBoxSize} />
    <UnreadCountBubble count={unreadCount} position="absolute" top="-5px" insetEnd="-5px" />
  </Center>
);

export default ConversationIcon;
